import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Rajesh Sharma", city: "Delhi", stars: 5, text: "Booked Innova from Jodhpur to Jaisalmer. Driver was on time, car spotless, and the price was exactly as quoted. Trusted them for our next family trip." },
  { name: "Priya Menon", city: "Bangalore", stars: 5, text: "Airport pickup at 2 AM went perfectly. The driver was polite, spoke English, and even helped with luggage. 10/10." },
  { name: "Amit Patel", city: "Ahmedabad", stars: 5, text: "5-day Rajasthan heritage tour with Mamta was a dream. Every hotel, every meal, every kilometre was smooth." },
  { name: "Sara Iyer", city: "Mumbai", stars: 5, text: "Their tempo traveller for our 12-person group was clean, comfortable and had wi-fi. Kids loved it. Highly recommend!" },
  { name: "Vikram Singh", city: "Chandigarh", stars: 5, text: "Best cab service in Jodhpur, hands down. Called at 7 AM, cab arrived by 7:15. Nothing beats that." },
];

export default function Reviews() {
  return (
    <section id="reviews" className="bg-white text-brand-ink py-24 md:py-32" data-testid="reviews-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] font-semibold text-brand-blue">Chapter VI · Reviews</div>
            <h2 className="mt-4 font-display font-black text-5xl md:text-6xl leading-[1.02]">
              A thousand <span className="italic text-brand-orange font-medium">thank-yous.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex text-brand-orange">
              {[0,1,2,3,4].map((s) => <Star key={s} className="w-5 h-5 fill-current" />)}
            </div>
            <div className="text-sm text-brand-ink/70"><span className="font-semibold text-brand-ink">4.9</span> / 5 · 1000+ reviews</div>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
              className={`relative rounded-3xl border border-brand-ink/8 bg-brand-cream/50 p-7 flex flex-col ${i === 0 ? "lg:row-span-2 lg:min-h-[400px] bg-brand-blue text-white" : ""}`}
              data-testid={`review-${i}`}
            >
              <Quote className={`w-8 h-8 ${i === 0 ? "text-brand-orange" : "text-brand-orange/70"}`} />
              <blockquote className="mt-4 font-display text-xl md:text-[22px] leading-snug">
                “{r.text}”
              </blockquote>
              <div className="mt-auto pt-6 flex items-center justify-between">
                <figcaption>
                  <div className="font-semibold">{r.name}</div>
                  <div className={`text-xs ${i === 0 ? "text-white/70" : "text-brand-ink/60"}`}>{r.city}</div>
                </figcaption>
                <div className={`flex ${i === 0 ? "text-white" : "text-brand-orange"}`}>
                  {[0,1,2,3,4].map((s) => <Star key={s} className="w-4 h-4 fill-current" />)}
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
